module.exports = __webpack_public_path__ + "img/a1.8e6ad191.jpg";